import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var courseListRes;
export const courseListTodo = createAsyncThunk('courseList', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/view_course_list',
            data: {
                "user_id": user_id.vemp_code,
                "temp": val.temp,
                "user_role": user_id.vrole_name,
                "course_availability": val.course_availability,
                "course_type": val.course_type,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return courseListRes = res.data
    } catch (error) {
        return courseListRes = error.response.data
    }
})


const courseListSlice = createSlice({
    name: 'courseList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(courseListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('courseList', state.data)
            }
        });
        builder.addCase(courseListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default courseListSlice.reducer; 